<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modification échéancier</strong>
          </div>
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <label for="annee">Année</label>
            	<b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="annee" type="text" :class="{hasError: errors.annee !== ''}" v-model="annee"></b-form-input>
                <span class="field-error">{{ errors.annee }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group
                label="Janvier"
                label-for="janvier"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m1" type="text" :class="{hasError: errors.m1 !== ''}" v-model="m1"></b-form-input>
                <span class="field-error">{{ errors.m1 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Février"
                label-for="fevrier"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m2" type="text" :class="{hasError: errors.m2 !== ''}" v-model="m2"></b-form-input>
                <span class="field-error">{{ errors.m2 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Mars"
                label-for="mars"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m3" type="text" :class="{hasError: errors.m3 !== ''}" v-model="m3"></b-form-input>
                <span class="field-error">{{ errors.m3 }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group
                label="Avril"
                label-for="avril"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m4" type="text" :class="{hasError: errors.m4 !== ''}" v-model="m4"></b-form-input>
                <span class="field-error">{{ errors.m4 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Mai"
                label-for="mai"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m5" type="text" :class="{hasError: errors.m5 !== ''}" v-model="m5"></b-form-input>
                <span class="field-error">{{ errors.m5 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Juin"
                label-for="juin"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m6" type="text" :class="{hasError: errors.m6 !== ''}" v-model="m6"></b-form-input>
                <span class="field-error">{{ errors.m6 }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group
                label="Juillet"
                label-for="juillet"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m7" type="text" :class="{hasError: errors.m7 !== ''}" v-model="m7"></b-form-input>
                <span class="field-error">{{ errors.m7 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Août"
                label-for="aout"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m8" type="text" :class="{hasError: errors.m8 !== ''}" v-model="m8"></b-form-input>
                <span class="field-error">{{ errors.m8 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Septembre"
                label-for="septembre"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m9" type="text" :class="{hasError: errors.m9 !== ''}" v-model="m9"></b-form-input>
                <span class="field-error">{{ errors.m9 }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group
                label="Octobre"
                label-for="octobre"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m10" type="text" :class="{hasError: errors.m10 !== ''}" v-model="m10"></b-form-input>
                <span class="field-error">{{ errors.m10 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Novembre"
                label-for="novembre"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m11" type="text" :class="{hasError: errors.m11 !== ''}" v-model="m11"></b-form-input>
                <span class="field-error">{{ errors.m11 }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Décembre"
                label-for="decembre"
              >
                <b-form-input v-bind:disabled="!canAccess(rules.MANAGE_ECHEANCIER)" id="m12" type="text" :class="{hasError: errors.m12 !== ''}" v-model="m12"></b-form-input>
                <span class="field-error">{{ errors.m12 }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="type"><strong>Commentaire</strong></label>
                <div v-if="canAccess(rules.MANAGE_ECHEANCIER)">
                  <editor :content.sync="contentForEditor" useCustomImageHandler></editor>
                  <span class="field-error">{{ errors.contentForEditor }}</span>
                </div>
                <div v-html="contentForEditor" v-else>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row  v-if="canAccess(rules.MANAGE_ECHEANCIER)">
            <b-col sm="3">
              <b-form-checkbox id="is_delayed" type="text" :class="{hasError: errors.is_delayed !== ''}" v-model="is_delayed">
                Activer
              </b-form-checkbox>
              <span class="field-error">{{ errors.is_delayed }}</span>
            </b-col>
          </b-row>
          <div slot="footer" v-if="canAccess(rules.MANAGE_ECHEANCIER)">
            <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "@/utils/auth";
import {espaceBeneficiaireRules, hasRule} from '@/utils/rulesHelper'
import Editor from '../../../components/Editor.vue'

export default {
  rules: espaceBeneficiaireRules,
  components: {
    Editor
  },
  data() {
  	return {
      rules: espaceBeneficiaireRules,
      annee: '',
      contentForEditor: '',
      is_delayed: '',
      m1: '', m2: '', m3: '', m4: '', m5: '', m6: '', 
      m7: '', m8: '', m9: '', m10: '', m11: '', m12: '', 
      errors: {
        annee: '',
        contentForEditor: '',
        is_delayed: '',
        m1: '', m2: '', m3: '', m4: '', m5: '', m6: '', 
        m7: '', m8: '', m9: '', m10: '', m11: '', m12: ''
      },
      contentForEditor: '',
  	};
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.get();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    get() {
      this.$store.commit('IS_LOADING', true)
      let self = this;
       this.$axios
        .get("/espaceBeneficiaire/echeancier/index")
        .then(response => {
          this.annee = response.data.echeancier.annee;
          this.m1 = response.data.echeancier.m1;
          this.m2 = response.data.echeancier.m2;
          this.m3 = response.data.echeancier.m3;
          this.m4 = response.data.echeancier.m4;
          this.m5 = response.data.echeancier.m5;
          this.m6 = response.data.echeancier.m6;
          this.m7 = response.data.echeancier.m7;
          this.m8 = response.data.echeancier.m8;
          this.m9 = response.data.echeancier.m9;
          this.m10 = response.data.echeancier.m10;
          this.m11 = response.data.echeancier.m11;
          this.m12 = response.data.echeancier.m12;
          this.contentForEditor = response.data.echeancier.is_delayed_text;
          this.is_delayed = response.data.echeancier.is_delayed;
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          if(error.response && error.response.status === 404 && self != undefined){
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue, merci de contacter l\'administrateur',showConfirmButton: false, timer: 5000})
          }
        });
    },
    edit() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let dataPost = {};
        dataPost.annee = this.annee;
        dataPost.m1 = this.m1;
        dataPost.m2 = this.m2;
        dataPost.m3 = this.m3;
        dataPost.m4 = this.m4;
        dataPost.m5 = this.m5;
        dataPost.m6 = this.m6;
        dataPost.m7 = this.m7;
        dataPost.m8 = this.m8;
        dataPost.m9 = this.m9;
        dataPost.m10 = this.m10;
        dataPost.m11 = this.m11;
        dataPost.m12 = this.m12;
        dataPost.is_delayed_text = this.contentForEditor;
        dataPost.is_delayed = this.is_delayed;

        this.$axios
          .put("/espaceBeneficiaire/echeancier/update", dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Modification de l\'échéancier avec succès', text:'L\'échéancier a bien été modifié',showConfirmButton: false, timer: 5000})
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Une erreur est survenue, merci de contacter l\'administration',showConfirmButton: false, timer: 5000})
          });
      }
    },
    validateData () {
      this.clearErrors();
      let regNumeric = this.$store.getters.getRegNumeric
      let valid = true

      // 1 3 5 7 8 10 12 => 31
      // 2 => 29
      // 4 6 9 11 => 30

      this.annee = this.annee + '';
      let annee = this.annee.replace(/ /g, "");
      if (annee !== '') {
        if (!regNumeric.test(annee)) {
          this.errors.annee = "L'année ne doit contenir que des chiffres"
          valid = false 
        } else if (annee.length < 4 || annee.length > 4) {
          this.errors.annee = "L'année doit contenir exactement 4 chiffres"
          valid = false
        }
      } else if (annee === '') {
        this.errors.annee = "L'année est obligatoire'"
        valid = false
      } 

      this.m2 = this.m2 + '';
      let m2 = this.m2.replace(/ /g, "");
      if (m2 !== '') {
        if (!regNumeric.test(m2)) {
          this.errors.m2 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m2.length < 1 || m2 > 29) {
          this.errors.m2 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m2 === '') {
        this.errors.m2 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m1 = this.m1 + '';
      let m1 = this.m1.replace(/ /g, "");
      if (m1 !== '') {
        if (!regNumeric.test(m1)) {
          this.errors.m1 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m1.length < 1 || m1 > 31) {
          this.errors.m1 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m1 === '') {
        this.errors.m1 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m3 = this.m3 + '';
      let m3 = this.m3.replace(/ /g, "");
      if (m3 !== '') {
        if (!regNumeric.test(m3)) {
          this.errors.m3 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m3.length < 1 || m3 > 31) {
          this.errors.m3 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m3 === '') {
        this.errors.m3 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m5 = this.m5 + '';
      let m5 = this.m5.replace(/ /g, "");
      if (m5 !== '') {
        if (!regNumeric.test(m5)) {
          this.errors.m5 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m5.length < 1 || m5 > 31) {
          this.errors.m5 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m5 === '') {
        this.errors.m5 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m7 = this.m7 + '';
      let m7 = this.m7.replace(/ /g, "");
      if (m7 !== '') {
        if (!regNumeric.test(m7)) {
          this.errors.m7 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m7.length < 1 || m7 > 31) {
          this.errors.m7 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m7 === '') {
        this.errors.m7 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m8 = this.m8 + '';
      let m8 = this.m8.replace(/ /g, "");
      if (m8 !== '') {
        if (!regNumeric.test(m8)) {
          this.errors.m8 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m8.length < 1 || m8 > 31) {
          this.errors.m8 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m8 === '') {
        this.errors.m8 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m10 = this.m10 + '';
      let m10 = this.m10.replace(/ /g, "");
      if (m10 !== '') {
        if (!regNumeric.test(m10)) {
          this.errors.m10 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m10.length < 1 || m10 > 31) {
          this.errors.m10 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m10 === '') {
        this.errors.m10 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m12 = this.m12 + '';
      let m12 = this.m12.replace(/ /g, "");
      if (m12 !== '') {
        if (!regNumeric.test(m12)) {
          this.errors.m12 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m12.length < 1 || m12 > 31) {
          this.errors.m12 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m12 === '') {
        this.errors.m12 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m4 = this.m4 + '';
      let m4 = this.m4.replace(/ /g, "");
      if (m4 !== '') {
        if (!regNumeric.test(m4)) {
          this.errors.m4 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m4.length < 1 || m4 > 30) {
          this.errors.m4 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m4 === '') {
        this.errors.m4 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m6 = this.m6 + '';
      let m6 = this.m6.replace(/ /g, "");
      if (m6 !== '') {
        if (!regNumeric.test(m6)) {
          this.errors.m6 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m6.length < 1 || m6 > 30) {
          this.errors.m6 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m6 === '') {
        this.errors.m6 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m9 = this.m9 + '';
      let m9 = this.m9.replace(/ /g, "");
      if (m9 !== '') {
        if (!regNumeric.test(m9)) {
          this.errors.m9 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m9.length < 1 || m9 > 30) {
          this.errors.m9 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m9 === '') {
        this.errors.m9 = "Le jour du mois est obligatoire"
        valid = false
      }

      this.m11 = this.m11 + '';
      let m11 = this.m11.replace(/ /g, "");
      if (m11 !== '') {
        if (!regNumeric.test(m11)) {
          this.errors.m11 = "Le jour du mois ne doit contenir que des chiffres"
          valid = false 
        } else if (m11.length < 1 || m11 > 30) {
          this.errors.m11 = "Le jour du mois est invalide"
          valid = false
        }
      } else if (this.m11 === '') {
        this.errors.m11 = "Le jour du mois est obligatoire"
        valid = false
      }

      return valid
    },
    clearErrors() {
      this.errors.annee = "";
      this.errors.m1 = "";
      this.errors.m2 = "";
      this.errors.m3 = "";
      this.errors.m4 = "";
      this.errors.m5 = "";
      this.errors.m6 = "";
      this.errors.m7 = "";
      this.errors.m8 = "";
      this.errors.m9 = "";
      this.errors.m10 = "";
      this.errors.m11 = "";
      this.errors.m12 = "";
    }
  }
};
</script>

<style>
</style>
